export class LicenseQueryParameters {
  embed?: string;
  id?: string;
  productId?: string;
  storeId?: string;
  userId?: string;
  utcCreatedSearchEnd?: Date;
  utcCreatedSearchStart?: Date;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
